<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm">
        <template slot="siteIds">
          <el-cascader
            v-model="detailFormData.siteIds"
              :options="options"
              :props="props"
              clearable></el-cascader>
        </template>
        <template slot="name">
            <el-input disabled v-model="detailFormData.name"></el-input>
        </template>
      </wt-detail-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UserAreaEditPage',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      isSubmitLoading: false,
      formUpdateUrl: '/modules/userEmployees/userAreaManagerUpdate',
      props: { multiple: true, children: 'children', label: 'name', value: 'id', emitPath: false, expandTrigger: 'hover' },
      options: [],
      detailForm: {
        title: '新增区域负责人',
        className: 'wt-section-long-content',
        elements: [
          { name: '账号',
            key: 'userName',
            type: 'text',
            required: false,
            disabled: true },
          { name: '姓名',
            key: 'name',
            type: 'custom',
            required: false,
            disabled: true },
          { name: '手机号',
            key: 'phone',
            type: 'text',
            required: false,
            disabled: true,
            rules: [
              { min: 11, max: 11, message: '手机号格式不正确', trigger: 'blur' },
              { pattern: this.$wtValidator.ValidatorPhonePattern, message: '手机号格式不正确', trigger: 'blur' }
            ] },
          { name: '站点',
            key: 'siteIds',
            type: 'custom',
            required: false,
            disabled: false }]
      },
      detailFormButtons: {
        title: '新增区域负责人',
        elements: [{ name: '提交', key: 'EDIT', action: 'EDIT', hidden: false, className: 'primary' },
          { name: '取消', key: 'CLOSE', action: 'CLOSE' }]
      },
      checkList: []
    }
  },
  created() {
    if (this.componentType === 'edit') {
      this.detailForm.elements[1].type = 'custom'
      this.detailForm.elements[1].required = false
      if (this.detailFormData.siteList) {
        const siteIds = []
        for (const item of this.detailFormData.siteList) {
          siteIds.push(item.id)
        }
        this.detailFormData.siteIds = siteIds
      }
    }
    this.siteTreeList()
    this.detailForm.title = this.componentType === 'edit' ? '编辑区域负责人' : '新增区域负责人'
  },
  methods: {
    onDetailButtonAction(item) {
      console.log(item)
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'EDIT') {
        this.onEdit()
      }
    },
    onEdit() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdate()
      }).catch(() => {
      })
    },
    requestUpdate() {
      const that = this
      const params = JSON.parse(JSON.stringify(this.detailFormData))
      params.communityId = ''
      for (const item of this.options) {
        if (item.siteResultList && !params.communityId) {
          for (const iitem of item.siteResultList) {
            if (params.siteIds.indexOf(iitem.id) > -1) {
              params.communityId = item.id
            }
          }
        }
      }
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: params,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        this.$emit('on-dialog-action', 'refresh')
      })
    },
    // 社区
    siteTreeList() {
      this.$api.siteManage.site.siteTreeListByOrg({
        isDeliveryEnabled: 0,
        type: 2
        // userId: this.componentType === 'edit' ? this.detailFormData.id : ''
      }).then(res => {
        this.options = res.data
      })
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.userMaster.userMasterDetailData
    })
  }
}
</script>
